import {
  AppBar,
  Avatar,
  Box,
  Button,
  CardHeader,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useReducer, useRef } from 'react';
import KenGridEditableData from '../../../../global_components/kenEditDataGrid/KenGridEcditableForStudentStatus';
import KenDialogBox from '../../../../global_components/KenDialogBox';

import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import Revulation from './Revulation.js';
import Retest from './Retest';
import KenCard from '../../../../global_components/KenCard';
import { useState } from 'react';
import TablePaginationActions from '../../../../global_components/KenGrid/TablePaginationActions';
import { getRetestData } from '../../../../Utils/apiServices';
import '../../../../style/index.css';
import routes from '../../../../Utils/routes.json';
import RetestExam from '../SeatingPlan/RetestExam';
import KenLoader from '../../../../Components/KenLoader';

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  header12: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    marginTop: '30px',
  },
  header1: {
    background: 'transparent',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  TitleBox: {
    display: 'flex',
    float: 'left',
    margin: '25px 10px',
    padding: '10px',
    background: '#fff',
  },
  TitleTextSpan: {
    fontSize: '16px',
    fontWeight: 'bolder',
    marginLeft: '10px',
  },
  TitleText: {
    fontSize: '10px',
    paddingLeft: '10px',
  },
  view: {
    color: 'white',
height: '35px',
    background: '#55b0cd',
width: '100px',
    borderRadius: '10px',
    fontSize: '12px',

    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',

      color: 'white',
    },
  },
}));

const RetestParent = () => {
  const history = useHistory();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const arrayBreadCrumb = [
    // { head: 'ADMIN PORTAL', url: routes.adminManagement },
    {
      head: 'EXAM',
      url: 'routes.exam',
    },
    {
      head: 'STUDENT STATUS',
    },
  ];

  const [retestData, setRetestData] = useState([]);

  // Paginations
  const [totalData, setTotalData] = useState(25);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // Pagination is over

  const [retestExamDialog, setRetestExamDialog] = useState(false);
  function handleRetestExamDialog() {
    setRetestExamDialog((prevState) => !prevState);
  }

  // Data
  const getRevalExamDetailsDataListing = () => {
    setLoading(true);
    getRetestData().then((res) => {
      const ReTestDetailsInfo =
        res === null
          ? []
          : res.map((item, index) => {
              return {
                id: item.id ? item.id : '',
                courseId: item.courseId ? item.courseId : '',

                program: item.programe ? item.programe : '',
                course: item.courseName ? item.courseName : '',
                term: item.termName ? item.termName : '',
                exam_date: item.examDate ? item.examDate : '',
                exam_type: item.examType ? item.examType : '',
                reason: item.reason ? item.reason : '',
                examCycle: item.examCycle ? item.examCycle : '',
                batch: item.Batch ? item.Batch : '',
                marks: item.previousMarks ? item.previousMarks : '',

                // student: item.studentName ? item.studentName : '',
                // exam_type: item.examType ? item.examType : '',
                // document_submitted: item.documentStatus
                //   ? item.documentStatus
                //   : '',
                // no_of_documents: item.numberofDocuments
                //   ? item.numberofDocuments
                //   : '',
                due_date: item.retestDueDate ? item.retestDueDate : '',
                // exam_date: item.examDate ? item.examDate : '',
                // status: item.status ? item.status : '',
                // reason: item.reason ? item.reason : '',
                // semester: item.semester ? item.semester : '',
              };
            });
      setLoading(false);

      setRetestData(ReTestDetailsInfo);
    });
  };

  useEffect(() => {
    getRevalExamDetailsDataListing();
  }, []);

  return (
    <Box>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            RETEST
          </Typography>
          {/* 
          <Button
            // startIcon={<RiFilterLine />}
            variant="contained"
            color="primary"
            style={{ marginRight: '15px' }}
            className={classes.addButton}
            onClick={handleRetestExamDialog}
          >
            Retest Exam
          </Button> */}
        </Toolbar>
      </AppBar>
      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  PROGRAMS
                </TableCell>

                <TableCell className="tableHeaderTitle" align="left">
                  TERM
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  DUE DATE
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  COURSE
                </TableCell>

                <TableCell className="tableHeaderTitle" align="left">
                  BATCH
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {retestData?.map((row) => (
                <TableRow
                  className="editableTableRowData editableTableRowDatas"
                  key={row.id}
                >
                  {/* <CustomTableCell {...{ row, name: 'name', onChange }} /> */}
                  <KenGridEditableData
                    {...{
                      row,
                      // onChange,
                      columns: [
                        {
                          column_name: 'program',
                          is_inline_edit: false,
                          inline_edit_type: '',
                          label: 'program',
                        },
                        {
                          column_name: 'term',
                          is_inline_edit: false,
                          inline_edit_type: '',
                          label: 'term',
                        },
                        {
                          column_name: 'due_date',
                          is_inline_edit: true,
                          inline_edit_type: 'kenDatePicker',
                          label: 'due_date',
                        },
                        {
                          column_name: 'course',
                          is_inline_edit: false,
                          inline_edit_type: '',
                          label: 'course',
                        },

                        {
                          column_name: 'batch',
                          is_inline_edit: false,
                          inline_edit_type: '',
                          label: 'batch',
                        },
                      ],
                    }}
                  />

                  <TableCell className={classes.selectTableCell}>
                    <Button
                      className={classes.view}
                      // color="primary"
                      size="small"
                      variant="primary"
                    >
                      <Link style={{color: 'white'}}
                        to={{
                          pathname: `${routes.retest}/${row?.courseId}`,
                          // state: { gradingId: ele?.courseOfferingId },
                        }}
                      >
                        View / Edit
                      </Link>
                    </Button>
                  </TableCell>
                </TableRow>
              ))}{' '}
            </TableBody>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              colSpan={10}
              count={totalData ? totalData : retestData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Table>
        </KenCard>
      </Box>
      <KenDialogBox
        open={retestExamDialog}
        handleClose={() => handleRetestExamDialog()}
        // negativeButtonClick={() => handleSendBulkMessageDialogNo()}
        // positiveButtonClick={() => handleSendBulkMessageDialogYes()}
        // positiveButtonText="Yes"
        // negativeButtonText="No"
        hidePositiveButton={true}
        hideNegativeButton={true}
        // dividers
      >
        <RetestExam
          retestExamDialog={retestExamDialog}
          setRetestExamDialog={setRetestExamDialog}
        />
      </KenDialogBox>
      {/* <div style={{ marginTop: '50px' }}>
        <AppBar position="static" elevation={0} className={classes.header}>
          <Revulation />
        </AppBar>
      </div>
      <AppBar position="static" elevation={0} className={classes.header12}>
        <Retest />
      </AppBar> */}
    </Box>
  );
};

export default RetestParent;
